import Suspense from "components/shared/Suspense";
import useMount from "hooks/useMount";
import { lazy } from "react";
import useCurrentUserId from "hooks/user/useCurrentUserId";

const PromptUserAnswersCount = lazy(() => import("./PromptUserAnswersCount"));

export default function PromptUserAnswersCountLoader({
  promptId,
}: {
  promptId: number;
}) {
  const userId = useCurrentUserId();
  const mounted = useMount();

  if (!userId || !mounted) {
    return <></>;
  }

  return (
    <Suspense>
      <PromptUserAnswersCount userId={userId} promptId={promptId} />
    </Suspense>
  );
}
